import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, FormGroup, Label, Input, Button, CustomInput } from "reactstrap"
import Cargando from '../../../../Varios/Cargando';
import IconCloseModal from '../../../../Varios/Modals/IconCloseModal';
import { FechasPermisosMedicosVacaciones, PlanificacionSolicitudVacaciones, Replanificacion, SolicitudReintegroVacacionesPost, SolicitudVacaciones } from '../TypesSolicitudVacaciones';
import Datepicker from '../../../../Varios/Datepicker';
import { function_calcular_dias_ordinarios, ObtenerFechaFromIsoFormat, obtener_rango_fechas_no_weekend, SumarDiasFecha, PruebaSolucion2, GetPreviousLaboralDay } from "../../../../../functions/DatesFunctions"
import { isFeriado, isFeriadoFilter, isWeekday } from "../../../../../functions/CalendarFunctions"
import PDFViewer from 'components/Varios/PDFViewer';
import { ObtenerVistaAccionPersonalSolicitudReintegroVacaciones } from '../FunctionsSolicitudVacaciones';
import TablePlanificaciones from '../TablePlanificaciones';
import DatePickerReprogramacion from '../Componentes Reprogramacion/DatePickerReprogramacion';
import AgregarReprogramacion from '../Componentes Reprogramacion/AgregarReprogramacion';
import { classNameIconoMenos } from 'constants/Icons-Font-Awesome';
import { SumDiasOrdinariosReplanificaciones } from './FunctionsModalAcciones';

export function verificarFechasContenidas(
    solicitud: SolicitudVacaciones,
    planificaciones: PlanificacionSolicitudVacaciones[]
): boolean {
    // Convertir las fechas string a Date objects para comparación
    const fechaInicioSolicitud = new Date(solicitud.fechaInicio);
    const fechaFinSolicitud = new Date(solicitud.fechaFin);

    // Verificar que las fechas de la solicitud sean válidas
    if (isNaN(fechaInicioSolicitud.getTime()) || isNaN(fechaFinSolicitud.getTime())) {
        console.error('Fechas de la solicitud no son válidas');
        return false;
    }

    // Buscar si alguna planificación contiene completamente las fechas de la solicitud
    return planificaciones.some(planificacion => {
        // Convertir fechas de la planificación
        
        const [anioinicio, mesinicio, diainicio] = planificacion.fechaInicio.toString().split("T")[0].split("-");
        const [aniofin, mesfin, diafin] = planificacion.fechaFin.toString().split("T")[0].split("-");

        const fechaInicioPlanificacion = new Date(+anioinicio, +mesinicio - 1, +diainicio);
        const fechaFinPlanificacion = new Date(+aniofin,+mesfin - 1,+diafin);

        // Verificar que las fechas de la planificación sean válidas
        if (isNaN(fechaInicioPlanificacion.getTime()) || isNaN(fechaFinPlanificacion.getTime())) {
            return false; // Saltar esta planificación si las fechas no son válidas
        }

        // Verificar si las fechas de la solicitud están completamente contenidas
        // en el rango de la planificación (incluyendo los límites)
        return fechaInicioSolicitud.getTime() >= fechaInicioPlanificacion.getTime() &&
            fechaFinSolicitud.getTime() <= fechaFinPlanificacion.getTime();
    });
}

export type PropsModalConfirmacion = {
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    asyncAccion: boolean,
    asyncClose: boolean,
    onClose: () => void,
    asyncAfterOnClose?: () => Promise<void>,
    onClick?: (observacion: string, fechaReintegro: Date) => void,
    asyncOnClick?: (observacion: string, fechaReintegro: Date, listadoReplanifificacion: Replanificacion[]) => Promise<number>;
    mensajeConfirmacion: string,
    classNamemensajeConfirmacion?: string,
    nombreBotonAccion: string,
    nombreBotonCerrarModal?: string,
    nombreBotonAfterOnClose?: string,
    closeAfterAccion: boolean
    hideBotonCerrar: boolean,
    contentModal?: HTMLElement
    tituloModal?: string
    labelObservacion: string
    labelFechaReintegro: string


    //Propiedades para reprogramacion de vacaciones
    solicitudes: SolicitudVacaciones[],
    solicitudVacaciones: SolicitudVacaciones,
    planificaciones: PlanificacionSolicitudVacaciones[],
    anioPlanificacion: number,
    feriados: Date[],
    fechasPermisosMedicos: FechasPermisosMedicosVacaciones[],
    fechasLicencia: {
        fechadesde: Date,
        fechahasta: Date,
    }[],

    maxlengthObservacion: number,
    fechaCorteSoloJustificaPlanificacion: Date

}

type StateModalConfirmacion = {
    realizandoAccion: boolean,
    accionTerminada: boolean,
    errorAsyncAccion: boolean,
    observacion: string
    fechaReintegro?: Date | string,
    urlVistaPreviaAP: string,
    loadingVistaPrevia: boolean,
    errorVistaPrevia: boolean,
    mensajeErrorVistaPrevia: string
}


export default function ModalReintegro(props: PropsModalConfirmacion) {

    const initialState: StateModalConfirmacion = {
        realizandoAccion: false,
        accionTerminada: false,
        errorAsyncAccion: false,
        fechaReintegro: undefined,
        observacion: "",
        urlVistaPreviaAP: "",
        loadingVistaPrevia: false,
        errorVistaPrevia: false,
        mensajeErrorVistaPrevia: ""
    }

    const [stateModal, setstateModal] = useState<StateModalConfirmacion>(initialState);

    //States de la planificacion que esta siendo Ingresada
    const [fechaDesdePlanificacion, setfechaDesdePlanificacion] = useState<Date | undefined>(undefined)
    const [fechaHastaPlanificacion, setfechaHastaPlanificacion] = useState<Date | undefined>(undefined)
    const [diaOrdinarioPlanificado, setdiaOrdinarioPlanificado] = useState<number>(0)
    const [servidorReprogramaraFechaOpcional, setservidorReprogramaraFechaOpcional] = useState<boolean>(false)
    //State de Lista de Replanificaciones
    const [listadoReplanificaciones, setlistadoReplanificaciones] = useState<Replanificacion[]>([])

    var esDePlanificacion = verificarFechasContenidas(props.solicitudVacaciones, props.planificaciones);
    const debeReprogramar: boolean = props.planificaciones.length > 0 && !props.solicitudVacaciones.permiso && esDePlanificacion;

    //Esto se hace porque en si, la primera reprogramación es oculta y es por default
    const diasReprogramados: number = SumDiasOrdinariosReplanificaciones(listadoReplanificaciones.slice(1));

    var diasPendientesPorReprogramar: number = props.solicitudVacaciones.diasOrdinarios - diasReprogramados;

    if (stateModal.fechaReintegro !== undefined) {
        diasPendientesPorReprogramar = function_calcular_dias_ordinarios(new Date(stateModal.fechaReintegro), new Date(props.solicitudVacaciones.fechaFin)) - diasReprogramados;
    }

    /*Esto es para simular que se ha llegado al periodo en que no es obligatoria la reprogramación
        const fechaActual = new Date(2023, 12, 12);
    */

    const fechaActual = new Date();

    const ReprogramacionOpcionalPorFecha: boolean = fechaActual.getTime() >= new Date(props.fechaCorteSoloJustificaPlanificacion).getTime()

    function CerrarModal() {
        setstateModal(initialState);

        props.onClose();
    }

    async function CerrarModalAndAfterClose(callbackClose: () => Promise<void>) {
        setstateModal(initialState);
        await callbackClose();

    }



    const AccionAsync = useCallback(
        async (callbackAccion: any) => {
            const { asyncAfterOnClose } = props;
            setstateModal({ ...stateModal, realizandoAccion: true })
            var statusAccion = await callbackAccion(stateModal.observacion, stateModal.fechaReintegro, listadoReplanificaciones);

            if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "function") {
                await CerrarModalAndAfterClose(asyncAfterOnClose);
            }
            else if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "undefined") {
                CerrarModal();
            }

            else {
                if (statusAccion > -1) {
                    setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true })
                }
                else {
                    setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true, errorAsyncAccion: true })
                }
            }

        },
        [stateModal, listadoReplanificaciones],
    )


    const AccionNotAsync = useCallback(
        (callbackAccion: any) => {

            const { closeAfterAccion } = props;
            callbackAccion(stateModal.observacion, stateModal.fechaReintegro);

            if (closeAfterAccion) {
                CerrarModal();
            }
        }, [stateModal])

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal handleClickIcon={() => CerrarModal()} />
        )
    }, [props])


    const BotonCancelar = useMemo(() => {
        return (
            <Button color="secondary" disabled={stateModal.realizandoAccion} onClick={() => CerrarModal()}> {props.nombreBotonCerrarModal !== undefined ? props.nombreBotonCerrarModal : "Cerrar Mensaje"} </Button>
        )
    }, [stateModal, props])



    const BotonVistaPrevia = useMemo(() => {

        const btnVistaPrevia = (<Button
            color="primary" data-bs-toggle="tooltip" data-bs-placement="top"
            title={"Debe generar la vista previa para poder enviar la solicitud"} className="mr-2"
            onClick={async () => await onClickVistaPrevia()}>{"Vista Previa"}
        </Button>
        )

        return btnVistaPrevia

    }, [props, stateModal])

    const BotonAccion = useMemo(() => {
        const { asyncOnClick, onClick } = props;


        // const condicionReprogramacion = (debeReprogramar && diasPendientesPorReprogramar > 0);
        var condicionReprogramacion = (debeReprogramar && listadoReplanificaciones.length === 1)
        if (debeReprogramar && ReprogramacionOpcionalPorFecha && !servidorReprogramaraFechaOpcional) {
            condicionReprogramacion = false
        }
        else if (debeReprogramar && ReprogramacionOpcionalPorFecha && servidorReprogramaraFechaOpcional && listadoReplanificaciones.length == 1) {
            condicionReprogramacion = true
        }

        //const disabled = stateModal.observacion === "" || stateModal.observacion === "def" || stateModal.fechaReintegro === undefined || stateModal.urlVistaPreviaAP === undefined || stateModal.urlVistaPreviaAP === "" || condicionReprogramacion

        const disabled = stateModal.observacion === "" || stateModal.observacion === "def" || stateModal.fechaReintegro === undefined || condicionReprogramacion

        const tiutloToolTip = disabled && !condicionReprogramacion ? "Debe indicar su fecha de reintegro y el motivo " : disabled && condicionReprogramacion ? "Debe reprogramar sus días no gozados " : "Solicitar Reintegro";

        if (props.asyncAccion && asyncOnClick) {

            const btnasyncAccion = <Button color="primary" data-bs-toggle="tooltip" data-bs-placement="top" title={tiutloToolTip} disabled={disabled} className="mr-2" onClick={async () => await AccionAsync(asyncOnClick)}>{props.nombreBotonAccion}</Button>
            return btnasyncAccion


        }
        else if (!props.asyncAccion && onClick) {
            return (
                <Button color="primary" disabled={disabled} className="mr-2" onClick={() => AccionNotAsync(onClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else {
            return (<div></div>)
        }


    }, [props, stateModal, listadoReplanificaciones, diasPendientesPorReprogramar, debeReprogramar, ReprogramacionOpcionalPorFecha, servidorReprogramaraFechaOpcional])

    const BotonCerrarYAccion = useMemo(() => {
        const { asyncAfterOnClose, nombreBotonAfterOnClose } = props

        if (asyncAfterOnClose && nombreBotonAfterOnClose) {
            return (
                <Button color="primary" id="botonAfterOnClose" className="mr-2" onClick={async () => await CerrarModalAndAfterClose(asyncAfterOnClose)}>{nombreBotonAfterOnClose ?? "Cerrar y Continuar"}</Button>
            )
        }
    }, [props, stateModal])


    async function VistaPreviaAPReintegro(stateModal: StateModalConfirmacion, props: PropsModalConfirmacion) {


        if (stateModal.fechaReintegro !== undefined && typeof (stateModal.fechaReintegro) !== "string") {
            setstateModal({ ...stateModal, loadingVistaPrevia: true })
            const solicitud: SolicitudReintegroVacacionesPost = {
                FechaReintegro: stateModal.fechaReintegro,
                IdSolicitudVacaciones: props.solicitudVacaciones.idSolicitud ?? -1,
                MotivoReintegro: stateModal.observacion
            }
            const respuesta = await ObtenerVistaAccionPersonalSolicitudReintegroVacaciones(solicitud);
            if (respuesta.status === 200) {
                setstateModal({ ...stateModal, loadingVistaPrevia: false, urlVistaPreviaAP: respuesta.dataResponse })
            }
            else {
                setstateModal({ ...stateModal, loadingVistaPrevia: false, errorVistaPrevia: true, mensajeErrorVistaPrevia: respuesta.errorMessage ?? "" })

            }

        }
    }


    const onClickVistaPrevia = useCallback(async () => {
        await VistaPreviaAPReintegro(stateModal, props)
    }, [stateModal.fechaReintegro, stateModal.observacion, props])



    const ListadoReprogramacionesComponent = useMemo(() => {


        if (listadoReplanificaciones.length > 0 && stateModal.fechaReintegro !== undefined) {

            const diasOrdinarios = function_calcular_dias_ordinarios(new Date(stateModal.fechaReintegro), new Date(props.solicitudVacaciones.fechaFin));
            const classNameFormGroup = "mb-0";
            const classNameLabel = "labelAReprogramar";
            const classNameInput = "inputAReprogramar"
            return (
                <React.Fragment>

                    <Row className="justify-content-start">
                        <Col xl={12}>
                            <p className='text-reprogramar'>{"Usted va a reprogramar el siguiente reintegro: "}</p>
                        </Col>
                    </Row>

                    <Row className="rowContainerFechaAReprogramar">
                        <Col xl={3} lg={2} md={12}>
                            <FormGroup className={classNameFormGroup}>
                                <Label for="fecha1DesdeReprogramacion" className={classNameLabel}>
                                    {"Fecha Desde"}
                                </Label>

                                <Input className={classNameInput} type="text" value={ObtenerFechaFromIsoFormat(new Date(stateModal.fechaReintegro).toISOString())} readOnly  ></Input>
                            </FormGroup>
                        </Col>
                        <Col xl={3} lg={2} md={12}>
                            <FormGroup className={classNameFormGroup}>
                                <Label for="fecha1HastaReprogramacion" className={classNameLabel}>
                                    {"Fecha hasta"}
                                </Label>

                                <Input className={classNameInput} type="text" value={ObtenerFechaFromIsoFormat(props.solicitudVacaciones.fechaFin.toString())} readOnly ></Input>
                            </FormGroup>
                        </Col>
                        <Col xl={3} lg={2} md={12}>
                            <FormGroup className={classNameFormGroup}>
                                <Label for="nroDiasOrdinariosReprogramacion" className={classNameLabel}>
                                    {"Nro días Ordinarios"}
                                </Label>

                                <Input className={classNameInput} type="text" value={diasOrdinarios} readOnly  ></Input>
                            </FormGroup>
                        </Col>
                    </Row>



                    <Row className="justify-content-start">
                        <Col xl={12}>
                            <p className='mb-0 labelReprogranacionReintegro'>{"Reprogramación"}</p>
                        </Col>
                    </Row>

                    {listadoReplanificaciones.map((v, i) => {
                        const fechaDesdeString = v.editable ? ObtenerFechaFromIsoFormat(PruebaSolucion2(v.fechaInicio)) : ObtenerFechaFromIsoFormat(v.fechaInicio.toString());
                        const fechaHastaString = ObtenerFechaFromIsoFormat(PruebaSolucion2(v.fechaFin))
                        if (v.showInTable !== undefined && v.showInTable === false) {
                            return undefined;
                        }
                        return (
                            <Row className="mb-2">
                                <Col xl={3} lg={2} md={12}>
                                    <Input className="marginModRein" type="text" value={fechaDesdeString} readOnly id={"reprogramacionReintegroDesde " + i} ></Input>
                                </Col>
                                <Col xl={3} lg={2} md={12}>
                                    <Input className="marginModRein" type="text" value={fechaHastaString} readOnly id={"reprogramacionReintegroHasta " + i} ></Input>
                                </Col>
                                <Col xl={3} lg={2} md={12}>
                                    <Input className="marginModRein" type="text" value={v.diasOrdinarios} readOnly id={"reprogramacionReintegroDias " + i} ></Input>
                                </Col>
                                {
                                    v.editable !== undefined && v.editable &&
                                    (
                                        <Col sm={1} md={1} className="columnIconMinusReprogramacion">
                                            <i
                                                className={classNameIconoMenos}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Eliminar"
                                                onClick={() => onClickRemoverReplanificacion(v)}
                                            />

                                        </Col>
                                    )
                                }

                            </Row>
                        )
                    })}
                </React.Fragment>

            )

        }
    }, [listadoReplanificaciones, stateModal.fechaReintegro])




    useEffect(() => {
        var esDePlanificacion = verificarFechasContenidas(props.solicitudVacaciones, props.planificaciones);
        const debeReprogramar: boolean = props.planificaciones.length > 0 && !props.solicitudVacaciones.permiso && esDePlanificacion
        if (stateModal.fechaReintegro !== undefined && debeReprogramar) {

            const fechaActual = new Date();
            // const fechaInicio = fechaActual.getTime() >= new Date(props.solicitudVacaciones.fechaInicio).getTime() ? SumarDiasFecha(fechaActual, 1) : props.solicitudVacaciones.fechaInicio;
            const fechaInicio = props.solicitudVacaciones.fechaInicio;

            const fechaFin = GetPreviousLaboralDay(new Date(stateModal.fechaReintegro), props.feriados);

            setlistadoReplanificaciones([{
                fechaInicio: fechaInicio,
                fechaFin: new Date(fechaFin),
                diasOrdinarios: function_calcular_dias_ordinarios(new Date(fechaInicio), new Date(fechaFin)),
                editable: false,
                showInTable: false
            }])
        }
    }, [stateModal.fechaReintegro, props, servidorReprogramaraFechaOpcional])

    useEffect(() => {
        if (!servidorReprogramaraFechaOpcional) {
            setlistadoReplanificaciones([])
        }
    }, [servidorReprogramaraFechaOpcional])


    function AddReplanificacion(listado: Replanificacion[], fechaDesde: Date, fechaHasta: Date) {
        const diasOrdinarios: number = function_calcular_dias_ordinarios(fechaDesde, fechaHasta);

        setlistadoReplanificaciones([
            ...listado,
            {
                fechaInicio: fechaDesde,
                fechaFin: fechaHasta,
                diasOrdinarios,
                editable: true,
                showInTable: true
            }
        ])

        setfechaDesdePlanificacion(undefined);
        setfechaHastaPlanificacion(undefined);
    }

    const onClickRemoverReplanificacion = useCallback(
        (replanificacion: Replanificacion) => {
            if (listadoReplanificaciones.length > 0) {


                const listadoNuevo = [...listadoReplanificaciones].filter((val) => !(val.fechaFin.getTime() === replanificacion.fechaFin.getTime() && val.fechaInicio.getTime() === replanificacion.fechaInicio.getTime()))

                setlistadoReplanificaciones(listadoNuevo)



                const totalDiasReplanificados = listadoNuevo.reduce((acum, cval) => acum + cval.diasOrdinarios, 0);
            }
        },
        [listadoReplanificaciones],
    )


    function ExcluirFechasParaDatePickerReintegro() {

        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })
        var fechasExcluidas: Date[] = [...feriados];

        if (props.fechasLicencia.length > 0) {

            props.fechasLicencia.map((val, ind) => {
                const { fechadesde, fechahasta } = val;
                fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechadesde, fechahasta)]
            })

        }

        if (props.fechasPermisosMedicos.length > 0) {

            props.fechasPermisosMedicos.map((val, ind) => {
                const { fechaDesde, fechaHasta } = val;
                fechasExcluidas = [...fechasExcluidas, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
            })

        }

        return fechasExcluidas;
    }



    const ContenidoModal = useMemo(() => {
        const { accionTerminada, realizandoAccion, errorAsyncAccion, observacion } = stateModal;
        const { asyncClose, solicitudVacaciones } = props;


        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0);

        // const diaAnterioActual  = SumarDiasFecha(fechaActual,-1)
        var excludeDates: Date[] = []


        const fechaInicioPicker = new Date(props.solicitudVacaciones.fechaInicio);
        const fechaFinPicker = new Date(props.solicitudVacaciones.fechaFin);



        if (fechaActual.getTime() > fechaInicioPicker.getTime()) {
            excludeDates = obtener_rango_fechas_no_weekend(fechaInicioPicker, fechaActual);
        }
        else {
            excludeDates = [fechaInicioPicker];
        }

        const fechasExcluir = ExcluirFechasParaDatePickerReintegro();

        excludeDates = [...excludeDates, ...fechasExcluir];

        const botonesAcciones = (
            <>
                {/* {<Col xl={2} lg={2} md={3}>{BotonVistaPrevia}</Col>} */}
                {!realizandoAccion && !accionTerminada && <Col xl={2} lg={2} md={3} className="d-flex ">{BotonAccion}</Col>}
                {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && <Col xl={2} lg={1} md={6} className="d-flex ">{BotonCerrarYAccion}</Col>}
                {!props.hideBotonCerrar && !realizandoAccion && <Col xl={2} lg={2} md={3} className="d-flex ">{BotonCancelar}</Col>}
            </>

        )





        return (
            <Container>
                <Row className="justify-content-start">
                    {
                        !realizandoAccion && !accionTerminada &&
                        <Col xl={8} lg={8} md={12}>
                            <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                        </Col>
                    }


                </Row>

                {
                    props.contentModal
                }

                <Row className="justify-content-start mt-2">
                    <Col xl={3} lg={3} md={12}>
                        <FormGroup>
                            <Label for="fechaReintegro">
                                {props.labelFechaReintegro + "*"}
                            </Label>
                            <div onClick={(e) => e.stopPropagation()}>
                                <Datepicker
                                    value={stateModal.fechaReintegro}
                                    name="fechaReintegro"
                                    id="fechaReintegro"
                                    onChange={(e) => setstateModal({ ...stateModal, fechaReintegro: e })}
                                    min={fechaInicioPicker}
                                    max={fechaFinPicker}
                                    showDisabledMonthNavigation={true}
                                    excludeDates={excludeDates}
                                    filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
                                    dayClassName={(date: Date) => isFeriado(date, props.feriados)}
                                    //portalId = {"rootModal"}
                                    //portalId={"modalReintegroVacaciones"}
                                //
                                />

                            </div>





                        </FormGroup>

                    </Col>
                    <Col xl={3} lg={2} md={12}>
                        <FormGroup>
                            <Label for="fechaHasta">
                                {"Fecha hasta"} <label style={{ visibility: 'hidden' }}>aaaaaaaaaa</label>
                            </Label>

                            <Input className="marginModRein" type="text" value={ObtenerFechaFromIsoFormat(props.solicitudVacaciones.fechaFin.toString())} readOnly id="fechahastaReintegro"></Input>
                        </FormGroup>

                    </Col>

                    <Col xl={3} lg={3} md={12}>
                        <FormGroup>
                            <Label for="diasreintegrarse">
                                {"Días a reintegrarse"} <label style={{ visibility: 'hidden' }}>aaaaaaa</label>
                            </Label>
                            {
                                stateModal.fechaReintegro !== undefined &&
                                <Input className="marginModRein" type="text" value={function_calcular_dias_ordinarios(new Date(stateModal.fechaReintegro), new Date(props.solicitudVacaciones.fechaFin))} readOnly id="diasreintegrarse"></Input>
                            }
                            {
                                stateModal.fechaReintegro === undefined &&
                                <Input className="marginModRein" type="text" value={""} readOnly id="diasreintegrarse"></Input>

                            }

                        </FormGroup>

                    </Col>

                </Row>

                <Row className="justify-content-center mb-2">
                    <Col>
                        <FormGroup>
                            <Label for="observacionRechazo">
                                {props.labelObservacion}
                            </Label>

                            <Input
                                type="select"
                                id="observacionRechazo"
                                name="observacionRechazo"
                                value={observacion}
                                onChange={(e) => setstateModal({ ...stateModal, observacion: e.target.value })}
                                defaultValue={"def"}
                            >
                                <option value={"def"}>Seleccione justificación</option>
                                <option value={"Necesidad institucional"}>Necesidad institucional</option>

                            </Input>




                        </FormGroup>
                    </Col>

                </Row>
                {
                    (stateModal.observacion === "" || stateModal.observacion === "def" || stateModal.fechaReintegro === undefined) &&
                    <Row className="justify-content-center">
                        <Col>
                            <p className='small-error'>{"Por favor, complete los datos"}</p>
                        </Col>

                    </Row>
                }


                {
                    debeReprogramar && stateModal.fechaReintegro !== undefined &&
                    <React.Fragment>
                        {ReprogramacionOpcionalPorFecha &&
                            <Row>
                                <Col sm={12} md={12}>
                                    <FormGroup tag="fieldset">
                                        <div className='ParentCheckReplanificar'>
                                            <div className='textReplanificar'>{"¿Desea replanificar? "}</div>
                                            <div>
                                                <FormGroup check inline>

                                                    <Label check>
                                                        <Input checked={servidorReprogramaraFechaOpcional} disabled={!debeReprogramar} onChange={(e) => setservidorReprogramaraFechaOpcional(true)} type="radio" />
                                                        {"Si"}
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check inline>
                                                    <Label check>
                                                        <Input checked={!servidorReprogramaraFechaOpcional} disabled={!debeReprogramar} onChange={(e) => setservidorReprogramaraFechaOpcional(false)} type="radio" />
                                                        {"No"}
                                                    </Label>
                                                </FormGroup>
                                            </div>

                                        </div>


                                    </FormGroup>



                                </Col>
                            </Row>
                        }



                        <React.Fragment>
                            {
                                debeReprogramar && (!ReprogramacionOpcionalPorFecha || (ReprogramacionOpcionalPorFecha && servidorReprogramaraFechaOpcional)) &&
                                <React.Fragment>
                                    <TablePlanificaciones
                                        celdaCheck={() => { return <></> }}
                                        showColumnSeleccionar={false}
                                        planificacionesDelAnio={props.planificaciones}
                                        anio={props.anioPlanificacion}

                                    />

                                    {ListadoReprogramacionesComponent}

                                    {
                                        diasPendientesPorReprogramar > 0 &&
                                        (<Row className="mt-2 mb-2">
                                            <Col md={12}>
                                                <small className='small-error'> {`Puede reprogramar hasta ${diasPendientesPorReprogramar} día(s) ordinario(s)`}</small>
                                            </Col>
                                        </Row>)
                                    }

                                    {
                                        <AgregarReprogramacion
                                            diasPendientes={diasPendientesPorReprogramar}
                                            fechaDesdeReprogramacion={fechaDesdePlanificacion}
                                            onChangeDateDesde={(e) => setfechaDesdePlanificacion(e)}
                                            fechaHastaReprogramacion={fechaHastaPlanificacion}
                                            onChangeDateHasta={(e) => setfechaHastaPlanificacion(e)}
                                            onClickLimpiarReprogramacion={() => { setfechaDesdePlanificacion(undefined); setfechaHastaPlanificacion(undefined) }}

                                            fechasLicencia={props.fechasLicencia}
                                            fechasPermisosMedicos={props.fechasPermisosMedicos}
                                            feriados={props.feriados}
                                            solicitudes={props.solicitudes}
                                            solicitudesReintegro={[]}
                                            solicitudVacacionDeReintegro={props.solicitudVacaciones}

                                            justificacionReplanificada={true}
                                            listadoReplanificaciones={listadoReplanificaciones}
                                            mostrarComponente={true}
                                            mensajeErrorListadoReplanificaciones=''
                                            mensajeErrorPlanificacion=''
                                            onAddReprogramacion={(fd: Date, fh: Date) => AddReplanificacion(listadoReplanificaciones, fd, fh)}
                                            planificaciones={props.planificaciones}
                                            permitirMenosDias={true}

                                            solicitudReprogramando='reintegro'
                                            fechaReintegro={stateModal.fechaReintegro}
                                        />
                                    }

                                </React.Fragment>
                            }


                        </React.Fragment>



                    </React.Fragment>

                }


                <Row className="justify-content-center">

                    {
                        botonesAcciones
                    }



                </Row>
                <Row>
                    <Col>
                        {
                            realizandoAccion && !accionTerminada &&
                            <Row className="justify-content-center">
                                <Cargando />
                            </Row>
                        }
                    </Col>

                </Row>
                <Row className="justify-content-center">
                    <Col>
                        {
                            !realizandoAccion && accionTerminada && !errorAsyncAccion &&
                            <p className='error-small'>Se ha completado la acción</p>
                        }
                        {
                            !realizandoAccion && accionTerminada && errorAsyncAccion &&
                            <p className='error-small'>Ha ocurrido un inconveniente al tratar de realizar la acción</p>
                        }
                    </Col>
                </Row>
                {stateModal.loadingVistaPrevia &&
                    <Row className="justify-content-center" id="RowCargandoVP">
                        <Col>
                            <Cargando mensaje='Cargando Acción Personal' />
                        </Col>
                    </Row>
                }

                {stateModal.urlVistaPreviaAP !== undefined && stateModal.urlVistaPreviaAP !== "" &&
                    <Row>
                        <Col>
                            <PDFViewer url={stateModal.urlVistaPreviaAP} heightValue={"100%"} />
                        </Col>
                    </Row>
                }

                {
                    stateModal.errorVistaPrevia && stateModal.mensajeErrorVistaPrevia !== undefined &&
                    <Row>
                        <Col>
                            <p className="small-error text-center">{stateModal.mensajeErrorVistaPrevia ?? "No es posible mostrar la Acción de Personal para su revisión"} </p>
                        </Col>
                    </Row>

                }
            </Container>
        )
    }, [props, stateModal, listadoReplanificaciones, fechaDesdePlanificacion, fechaHastaPlanificacion, servidorReprogramaraFechaOpcional])




    return (
        <Modal
            id="modalReintegroVacaciones"
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={false}
            onClosed={() => CerrarModal()}
            contentClassName="contentReintegro"
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal ? props.tituloModal : "Mensaje de confirmación"}</div>
            </ModalHeader>
            <ModalBody className="">
                <>

                    {ContenidoModal}
                </>

            </ModalBody>

        </Modal>
    )
}
